import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { Trans } from "react-i18next";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import ButtonMenu from "../ButtonMenu";
import KpsEditor from "../editor/KpsEditor";
import shortid from "shortid";
import axios from "../../AxiosClient";
import { containsScriptOrSVG, containsBadCharacter } from "../../utils/ContentChecker";
import {
  setGlobalAlert
} from "../../redux/actions/universalActions";
const styles = (theme) => ({
  root: {
    width: "100%",
  },
  text: {
    margin: 0,
    padding: "0 0 0 16px",
  },
  displayShow: {
    display: "block",
  },
  noDisplay: {
    display: "",
  },
  displayHide: {
    display: "none",
  },
});
export class PortletAttachment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEdit: false,
      menuVisibility: "hidden",
      text: "",
      attachmentIds: [],
    };
    this.deleteAttachment = this.deleteAttachment.bind(this);
    this.editAttachment = this.editAttachment.bind(this);
    this.changeMenuVisibility = this.changeMenuVisibility.bind(this);
  }
  componentDidMount() {
    if (this.props.attachment.text) {
      this.setState({
        text: this.props.attachment.text,
      });
    }
  }
  openEditAttachment = () => {
    this.setState({
      showEdit: !this.state.showEdit,
    });
  };
  deleteAttachment = () => {
    axios
      .delete(
        `/portalLayout/${this.props.portalLayout.id}/portlet/${
          this.props.portlet.id
        }/portletattachment/${this.props.attachment.id}`
      )
      .then((res) => {
        this.props.onAttachmentDelete(this.props.attachment.id);
      });
  };
  editorChange = (event) => {
    this.setState({ text: event });
  };
  newUploadId = (response) => {
    let attachments = this.state.attachmentIds.splice(0);
    attachments.push(Number(response));
    this.setState({ attachmentIds: attachments });
  };
  editAttachment = () => {
    if (containsScriptOrSVG([this.state.text])) {
      this.props.setGlobalAlert({type:"error", message:"harmful_content", open:true})
      return;
    } else if (containsBadCharacter([this.state.text])){
      this.props.setGlobalAlert({type:"error", message:"unusable_character", open:true})
      return;
    }
    let newAttachment = Object.assign({}, this.props.attachment);
    newAttachment.text = this.state.text;
    newAttachment.attachmentIds=this.state.attachmentIds;
    axios
      .patch(
        `/portalLayout/${this.props.portalLayout.id}/portlet/${
          this.props.portlet.id
        }/portletattachment/${this.props.attachment.id}`,
        {
          ...newAttachment,
        }
      )
      .then((res) => {
        this.openEditAttachment();
        this.props.onAttachmentUpdate(res.data);
      });
  };
  render() {
    const { classes } = this.props;
    const saveButton = this.state.showEdit ? "" : "none";
    const cancelButton = this.state.showEdit ? "" : "none";
    const content = this.state.showEdit ? "block" : "none";
    const textTwo = this.state.showEdit ? "none" : "block";
    return (
      <div
        id="attachment"
        className={classes.text}
        onMouseOver={this.changeMenuVisibility}
        onMouseOut={this.changeMenuVisibility}
        style={{ display: "flex", flexDirection: "row" }}
      >
        {this.state.showEdit ? (
          <div style={{ flexDirection: "row" }}>
            <KpsEditor
              initialContent={this.props.attachment.text}
              updateUploadArray={this.updateUploadArray}
              onChange={this.editorChange}
              ref="section"
              newUploadId={this.newUploadId}
            />
            <Button
              variant="contained"
              style={{ display: cancelButton }}
              onClick={this.openEditAttachment}
            >
              <Trans i18nKey="global_cancel" />
            </Button>
            <Button
              variant="contained"
              style={{ display: saveButton }}
              onClick={this.editAttachment}
            >
              <Trans i18nKey="global_save" />
            </Button>
          </div>
        ) : (
          <>
            <KpsEditor readOnly initialContent={this.props.attachment.text} />
            <div
              id="menu"
              style={{ visibility: this.state.menuVisibility }}
              className={classes.menu}
            >
              <ButtonMenu>
                <MenuItem onClick={this.openEditAttachment}>
                  <Trans i18nKey="portlet_attachment_edit_text" />
                </MenuItem>
                <MenuItem onClick={this.deleteAttachment}>
                  <Trans i18nKey="portlet_attachment_delete_text" />
                </MenuItem>
              </ButtonMenu>
            </div>
          </>
        )}
      </div>
    );
  }
  updateUploadArray = (array) => {
    this.setState({ attachmentIds: array });
  };
  changeMenuVisibility = () => {
    if (this.state.menuVisibility == "hidden") {
      this.setState({ menuVisibility: "visible" });
    } else {
      this.setState({ menuVisibility: "hidden" });
    }
  };
}

const mapStateToProps = (state) => ({
  portalLayout: state.layout.currentLayout,
});

const mapDispatchToProps = {
  setGlobalAlert,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PortletAttachment));
